module.exports = __webpack_public_path__ + "fonts/4b189acc6736f88519e50850c5f6a5bf.svg";